module.exports = __webpack_public_path__ + "static/usertesting-06ca334c1db536a246bd501ca9beb5c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/marvel-vs-invision/usertesting.png
// module id = 2663
// module chunks = 260617349216052